
import { Container, Row, Col, Button, Image } from "react-bootstrap";
import { Links } from "../../Links";
import AppStoreSvg from "../component/ButtonComponents/appstore";
import PlayStoreSvg from "../component/ButtonComponents/playstore";





import "../../homepage/homepage.css";


import MobileInterface from '../../../assets/MobileInterface.svg';



function HeroSection() {



  return (
    <Container fluid id="hero" className="herosection">
      <Container fluid className="containersection">

        <Row>
          <Col xs={12} sm={12} md={8} lg={7} className="textsection">
            <div style={{ display: 'flex', flexDirection: 'column', gap: -1, fontFamily: 'jost', }}>
              <h1 className="herotitle" style={{ color: '#FFFFFF' }}>
                <strong>
                  <span style={{ color: '#F36F2E' }}>Easy</span> moves,
                </strong>
              </h1>
              <h1 className="herotitle" style={{ color: '#FFFFFF' }} >
                <strong>
                  <span style={{ color: '#F36F2E' }}>Endless</span> possibilities.
                </strong>
              </h1>
            </div>
            <p style={{ color: '#ffffff', fontSize: 0.79 + 'rem', fontFamily: 'jost', lineHeight: 195 + '%', }}>
              Unlock new opportunities with Lodapoint App: From quick rides to heavy loads, Lodapoint moves it all with ease. Your journey, our priority.
            </p>
            {/* count down */}
            {/* <CountdownTimer targetDate={targetDate} /> */}
            <br />
            <div style={{ display: "flex", gap: 3 }}>

              <Button
                variant="primary"
                href={Links.User.playStore}
                target="_blank"
                rel="noopener noreferrer"

                style={{
                  backgroundColor: "#F36F2E",
                  borderColor: "#313434",
                  borderRadius: 36 + "px",
                  paddingTop: 7 + 'px'

                }}
                className="buttondownload"
                size="sm"
              >
                <PlayStoreSvg />
              </Button>

              <Button
                variant="primary"
                href={Links.User.appStore}
                target="_blank"
                rel="noopener noreferrer"

                style={{
                  backgroundColor: "#F36F2E",
                  borderColor: "#313434",
                  color: "#FFFFF",
                  borderRadius: 36 + "px",
                  paddingTop: 7 + 'px'

                }}
                className="buttondownload"
                size="sm"
              >
                <AppStoreSvg />

              </Button>
            </div>



          </Col>
          <Col xs={12} sm={12} md={4} lg={5} className="imagesection">
            <center>
              <Image className="mobilephone" src={MobileInterface} alt="image" />
            </center>


          </Col>
        </Row>
      </Container>




    </Container>
  );
}

export default HeroSection;
